// Shared types and field-type category constants for the EmployeeQueryBuilder.
import type { ICohortQueryModel } from "@performyard/models";

import type { IEmployeeField } from "../../api/services";

export type EmployeeQuery = ICohortQueryModel;
export type QueryCondition = ICohortQueryModel["and"][number]["or"][number];
export type { IEmployeeField };

export type DateSubType = "static" | "relative" | "anniversary";

export type ComparatorOption = {
	value: string;
	label: string;
};

export const NUMERIC_TYPES = ["numeric", "monetary", "salary", "rating-scale", "calculator"];
export const TEXT_TYPES = ["text", "textbox"];
export const DATE_TYPES = ["date"];
export const DROPDOWN_TYPES = ["single-select"];
export const PEOPLE_TYPES = ["person", "people"];
export const GROUP_TYPE = "department";

export const ALLOWED_FIELD_TYPES = [...NUMERIC_TYPES, ...TEXT_TYPES, ...DATE_TYPES, ...DROPDOWN_TYPES];
export const ALLOWED_FIELD_NAMES = ["Manager", "Group"];
